module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/youtube-play-4d50b4400af3a4c135103ffb789d4701.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/youtube-play.svg
// module id = qq2B
// module chunks = 24